/* eslint-disable consistent-return */
import fetchAuth from 'utils/fetchAuth'

const Console = console
const apiBaseUrl = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:64189'

const api = {
  getActiveEmployers() {
    const dataUrl = `${apiBaseUrl}/employers/active`
    return fetchAuth(dataUrl)
    .then(response => response.json())
    .catch((error) => {
      Console.log('Error getting active employers')
      Console.log(error)
      throw error
      })
    },

  getAllEmployers() {
    const dataUrl = `${apiBaseUrl}/employers/all`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting all employers')
        Console.log(error)
        throw error
      })
    },

  getNewEmployer() {
    const dataUrl = `${apiBaseUrl}/employers/new`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting new employer')
        Console.log(error)
        throw error
      })
    },

  getEmployer(employerId) {
    const dataUrl = `${apiBaseUrl}/employers/${employerId}`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting employer')
        Console.log(error)
        throw error
      })
    },

  getEmployerActiveContractors(employerId) {
    const dataUrl = `${apiBaseUrl}/employers/${employerId}/contractors/active`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting active contractors for employer')
        Console.log(error)
        throw error
      })
    },

  getEmployerAllContractors(employerId) {
    const dataUrl = `${apiBaseUrl}/employers/${employerId}/contractors`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting all contractors for employer')
        Console.log(error)
        throw error
      })
    },

  getJobRoles() {
    const dataUrl = `${apiBaseUrl}/contractors/jobroles`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting job roles')
        Console.log(error)
        throw error
      })
    },

  getEmployerName(employerId) {
    const dataUrl = `${apiBaseUrl}/employers/${employerId}`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .then(data => data.name)
      .catch((error) => {
        Console.log('Error getting company name')
        Console.log(error)
        throw error
      })
    },

  getNewContractor(employerId) {
    const dataUrl = `${apiBaseUrl}/employers/${employerId}/contractors/new`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting new contractor')
        Console.log(error)
        throw error
      })
    },

  getContractor(employerId, contractorId) {
    const dataUrl = `${apiBaseUrl}/employers/${employerId}/contractors/${contractorId}`

    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting contractor')
        Console.log(error)
        throw error
      })
    },

  getContractorName(employerId, contractorId) {
    const dataUrl = `${apiBaseUrl}/employers/${employerId}/contractors/${contractorId}`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .then(data => `${data.forename} ${data.surname}`)
      .catch((error) => {
        Console.log('Error getting contractor name')
        Console.log(error)
        throw error
      })
    },
    checkDuplicateCode(code) {
    const dataUrl = `${apiBaseUrl}/employers/getcodeasync?code=${code}`
    return fetchAuth(dataUrl)
    .then(response => response.json())
  .catch((error) => {
      console.log('Error getting new contractor');
      console.log(error);
      throw error;
  });
    },

   
  addEmployer(employer) {
    const dataUrl = `${apiBaseUrl}/employers`

    return fetchAuth(dataUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(employer)
    })
      .catch((error) => {
        Console.log('Error adding employer')
        Console.log(error)
        throw error
      })
    },

  updateEmployer(employer) {
    const dataUrl = `${apiBaseUrl}/employers/${employer.id}`
    return fetchAuth(dataUrl, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(employer)
    })
      .catch((error) => {
        Console.log('Error updating employer')
        Console.log(error)
        throw error
      })
    },

  addContractor(contractor) {
    const dataUrl = `${apiBaseUrl}/employers/${contractor.employerId}/contractors`
    return fetchAuth(dataUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contractor)
    })
      .catch((error) => {
        Console.log('Error adding contractor')
        Console.log(error)
        throw error
      })
    },

  updateContractor(contractor) {
    const dataUrl = `${apiBaseUrl}/employers/${contractor.employerId}/contractors/${contractor.id}`
    return fetchAuth(dataUrl, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contractor)
    })
      .catch((error) => {
        Console.log('Error updating contractor')
        Console.log(error)
        throw error
      })
    },

  updateContractorWithSimilarCheck(contractor) {
    const dataUrl = `${apiBaseUrl}/employers/${contractor.employerId}/contractors/issimilar`
    return fetchAuth(dataUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contractor)
    })
      .catch((error) => {
        Console.log('Error updating contractor with similar check')
        Console.log(error)
        throw error
      })
    },

  getFireRollCall(siteId, siteType) {
    const dataUrl = `${apiBaseUrl}/sites/${siteId}/firerollcall/open/${siteType}`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting fire roll call')
        Console.log(error)
        throw error
      })
    },

  getSites(query) {
    const dataUrl = `${apiBaseUrl}/propertylocator/?complete=${query}`
    return fetchAuth(dataUrl)
      .then(r => r.json())
      .then(r => r.results)
      .catch(() => [])
    },

  getSiteBySiteCode(query) {
    const dataUrl = `${apiBaseUrl}/propertylocator/?complete=${query}`
    return fetchAuth(dataUrl)
      .then(r => r.json())
      .then(r => r.results)
      .catch(() => [])
    },

  getPermissions() {
    const dataUrl = `${apiBaseUrl}/permissions`
    return fetchAuth(dataUrl)
      .then(r => r.json())
      .catch(() => { })  
    },

  getFeatures() {
    const dataUrl = `${apiBaseUrl}/features`
    return fetchAuth(dataUrl)
      .then(r => r.json())
      .catch(() => { })
    },

  getReport(reportName, reportOptions) {
    const dataUrl = `${apiBaseUrl}/${reportName}/?activePage=${reportOptions.activePage}&pageLength=${reportOptions.pageLength}&searchTerms=${reportOptions.searchTerms}`
    return fetchAuth(dataUrl)
      .then(r => r.json())
      .catch(() => [])
    },

  deleteBiometrics(deletionEntity) {
    const dataUrl = `${apiBaseUrl}/employers/${deletionEntity.employerId}/contractors/${deletionEntity.contractorId}/biometrics`

    return fetchAuth(dataUrl, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(deletionEntity)
    })
      .catch((error) => {
        Console.log('Error deleting contractor biometric')
        Console.log(error)
        throw error
      })
    },

  deleteContractor(deletionEntity) {
    const dataUrl = `${apiBaseUrl}/employers/${deletionEntity.employerId}/contractors/${deletionEntity.contractorId}`
    return fetchAuth(dataUrl, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(deletionEntity)
    })
      .catch((error) => {
        Console.log('Error deleting contractor')
        Console.log(error)
        throw error
      })
    },

  uploadContractorHours(contractorHours) {
    const dataUrl = `${apiBaseUrl}/import/contractedhours`
    return fetchAuth(dataUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contractorHours)
    })
      .catch((error) => {
        Console.log('Error uploading contractor hours')
        Console.log(error)
        throw error
      })
    },

  fetchFile(url) {
    const dataUrl = `${apiBaseUrl}${url}`
    const errorMessage = 'Error getting export csv'
    return fetchAuth(dataUrl)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        if (response.ok) {
          return response
        }
        return null
      })
      .catch((error) => {
        Console.log(errorMessage)
        Console.log(error)
        throw error
      })
    },

  getReportTypes() {
    const dataUrl = `${apiBaseUrl}/reports`
    return fetchAuth(dataUrl)
      .then(r => r.json())
      .catch((error) => {
        Console.log(errorMessage)
        Console.log(error)
        throw error
      })
    },

  embedReport(reportName) {
    const dataUrl = `${apiBaseUrl}/embedReport?reportName=${reportName}`
    return fetchAuth(dataUrl)
      .then(r => r.json())
      .catch((error) => {
        Console.log(errorMessage)
        Console.log(error)
        throw error
      })
    },

  getOutstandingPasses(siteCode) {
    const dataUrl = `${apiBaseUrl}/passes/outstanding/${siteCode}`
    return fetchAuth(dataUrl)
      .then(r => r)
      .then(response => response.json())
      .catch((error) => {
        Console.log(errorMessage)
        Console.log(error)
        throw error
      })
    },

  getUser() {
    const dataUrl = `${apiBaseUrl}/users`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting user')
        Console.log(error)
        throw error
      })
    },

  getPassDetailsAsync(visitId) {
    const dataUrl = `${apiBaseUrl}/passes/getPassDetails/${visitId}`
    return fetchAuth(dataUrl)
      .then(response => response.json())
      .catch((error) => {
        Console.log('Error getting pass details', error)
        throw error
      })
    },

  addVisitAction(action) {
    const dataUrl = `${apiBaseUrl}/visitPassActions`
    return fetchAuth(dataUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(action)
    })
      .catch((error) => {
        Console.log('Error adding pass action', error)
        throw error
      })
    },

  addSignOffPassesAsync(visitId, buttonText) {
    const dataUrl = `${apiBaseUrl}/passes/signoff/${visitId}/${buttonText}`
    return fetchAuth(dataUrl, {
      method: 'POST'
    })
      .catch((error) => {
        Console.log('Error signing off passes', error)
        throw error
      })
    },

    submitFeedback(appId, feedback) {
      const dataUrl = `${apiBaseUrl}/users/feedback`
      const data = {
        appId,
        rating: feedback.rating,
        comments: feedback.comment,
        feedbackBy: ''
      }
      return fetchAuth(dataUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .catch((error) => {
        Console.log('Error submitting feedback', error)
        throw error
      })
    }
  }

export { api as default }


// WEBPACK FOOTER //
// ./src/utils/api.js